import { Typography } from 'antd';
import styled from 'styled-components';

import { utils } from '@desygner/ui-common-components';

export const StyledWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => utils.rem(theme.Spacing.Size.XXSmall)};
  border-radius: ${({ theme }) => utils.rem(theme.Border.Radius.Medium)};
  background-color: ${({ theme }) => theme.Components.Panel.Background};
`;

export const StyledTypography = styled(Typography.Text)`
  width: ${({ theme }) => utils.rem(theme.Sizes.X8Large)};
  text-align: center;
`;

export const StyledMobileNavigationWrapper = styled(StyledTypography)`
  background-color: ${({ theme }) => theme.Color.Neutrals.Gray};
  border-radius: ${({ theme }) => utils.rem(theme.Border.Radius.XSmall)};
  padding: ${({ theme }) => utils.rem(theme.Spacing.Size.XXSmall)};
  color: ${({ theme }) => theme.Color.Neutrals.Paper};
`;
